@if (this.warningMessage?.description) {
  <div class="banner-warning">
    {{ this.warningMessage?.description }}
    @if (warningMessage?.link?.url) {
      <a [href]="warningMessage?.link?.url" target="_blank"> {{ warningMessage?.link?.text }}</a>
    }
  </div>
}

@if (!this.warningMessage?.description && this.displayEarlyAccess && this.earlyAccessMessage?.message && !close) {
  <div class="banner-learn-more">
    {{ this.earlyAccessMessage?.message }}
    @if (this.earlyAccessMessage?.link?.url) {
      <a [href]="this.earlyAccessMessage?.link?.url" target="_blank">
        {{ this.earlyAccessMessage?.link?.text }}
      </a>
    }
    <button type="button" class="close" mat-mini-fab (click)="close = true" color="warn">
      <mat-icon>close</mat-icon>
    </button>
  </div>
}
<system-message />
<mat-toolbar
  class="social-head"
  [ngClass]="{
    desktop: !inSocial,
    'header-v1': isPresentationActive || groupParticipantScreenShareActive(),
  }"
>
  <div class="head-text text-left">
    <app-social-leave-room [inSocial]="inSocial" nativeCursor></app-social-leave-room>
  </div>

  @if ((isPresentationActive || groupParticipantScreenShareActive()) && isMobile) {
    <img class="logo" src="assets/images/logos/scoot_logo_reverse.png" alt="Scoot" />
  }

  <span class="head-icon text-right">
    @if (!isGuest) {
      <profile-picture
        #menubutton
        nativeCursor
        class="profile-picture-wrap"
        [matMenuTriggerFor]="menu"
        [size]="40"
        [user]="user"
        [borderWidth]="'3'"
        [header]="true"
        style="float: right; margin-top: -2px; cursor: pointer"
        tabindex="0"
        role="button"
        aria-pressed="false"
        aria-label="Navigation Menu"
        aria-haspopup="true"
        (keyup.enter)="openMenu($event)"
        (keydown.enter)="$event.stopPropagation()"
      ></profile-picture>
    }

    <mat-menu #menu="matMenu" role="menu" aria-labelledby="menubutton">
      <a mat-menu-item role="menuitem" [routerLink]="['/web/settings']" target="_blank" rel="noopener noreferrer">
        My Settings
      </a>
      @if (userCompany && userCompany.companyName) {
        <a
          mat-menu-item
          role="menuitem"
          [routerLink]="['/web/admin/users']"
          class="hide-lt-md"
          target="_blank"
          rel="noopener noreferrer"
        >
          {{ userCompany.companyName | truncate: 20 }} Admin
        </a>
      }
      <a mat-menu-item role="menuitem" href="https://scoot.app/pricing/" target="_blank" rel="noopener noreferrer">
        Pricing & Features
      </a>
      <button mat-menu-item role="menuitem" (click)="signOut()">Sign Out</button>
    </mat-menu>
  </span>
</mat-toolbar>
